import React from 'react';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ForPhotographersPage() {
  return <>
      <SEO title="Aspect for Photographers" description="Work with Aspect on rights-cleared architectural documentation projects with clear compensation and professional standards." data-id="element-328" />
      <div className="space-y-24 md:space-y-32" data-id="element-329">
        {/* Intro */}
        <section className="max-w-2xl" data-id="element-330">
          <span className="text-aspect-gray block mb-4" data-id="element-331">For Photographers</span>
          <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-8 text-aspect-black" data-id="element-332">
            Work with Aspect on rights-cleared architectural documentation
            projects.
          </h1>
          <div className="mt-10" data-id="element-333">
            <Link to="/photographers/apply" data-id="element-334">
              <Button variant="primary" icon data-id="element-335">
                Apply to work with aspect
              </Button>
            </Link>
          </div>
        </section>

        {/* Why Photographers Work with Aspect */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-336">
          <div className="md:col-span-4" data-id="element-337">
            <span className="text-aspect-gray" data-id="element-338">Value</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-339">
            <h2 className="text-2xl font-medium" data-id="element-340">
              Why Photographers Work with Aspect
            </h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-341">
              <p data-id="element-342">
                Aspect offers structured assignments with clear rights,
                predictable compensation, and professional standards.
              </p>
              <p data-id="element-343">No ambiguity. No negotiation overhead. No rights confusion.</p>
            </div>
          </div>
        </section>

        {/* Assignment Model */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-344">
          <div className="md:col-span-4" data-id="element-345">
            <span className="text-aspect-gray" data-id="element-346">Assignments</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-347">
            <h2 className="text-2xl font-medium" data-id="element-348">Assignment Model</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-349">
              <p data-id="element-350">Photographers are assigned to projects based on:</p>
              <ul className="space-y-2 text-aspect-black/80" data-id="element-351">
                <li data-id="element-352">Geographic coverage</li>
                <li data-id="element-353">Project type and complexity</li>
                <li data-id="element-354">Availability and capacity</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Rights & Compensation */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-355">
          <div className="md:col-span-4" data-id="element-356">
            <span className="text-aspect-gray" data-id="element-357">Rights</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-358">
            <h2 className="text-2xl font-medium" data-id="element-359">Rights & Compensation</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-360">
              <p data-id="element-361">Rights terms are defined before assignment.</p>
              <p data-id="element-362">Compensation is structured and transparent.</p>
              <p data-id="element-363">Attribution follows the work.</p>
            </div>
          </div>
        </section>

        {/* Standards */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-364">
          <div className="md:col-span-4" data-id="element-365">
            <span className="text-aspect-gray" data-id="element-366">Standards</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-367">
            <h2 className="text-2xl font-medium" data-id="element-368">Documentation Standards</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-369">
              <p data-id="element-370">
                Aspect operates to defined technical and compositional
                standards.
              </p>
              <p data-id="element-371">
                Photographers receive clear briefs, shot lists, and verification
                requirements before each assignment.
              </p>
            </div>
          </div>
        </section>

        {/* What Photographers Are Not Asked to Do */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-372">
          <div className="md:col-span-4" data-id="element-373">
            <span className="text-aspect-gray" data-id="element-374">Scope</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-375">
            <h2 className="text-2xl font-medium" data-id="element-376">
              What Photographers Are Not Asked to Do
            </h2>
            <ul className="space-y-2 text-aspect-gray max-w-xl" data-id="element-377">
              <li data-id="element-378">Negotiate rights or usage terms</li>
              <li data-id="element-379">Coordinate access or permissions</li>
              <li data-id="element-380">Manage downstream licensing</li>
            </ul>
          </div>
        </section>

        {/* Application Process */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12 pb-12" data-id="element-381">
          <div className="md:col-span-4" data-id="element-382">
            <span className="text-aspect-gray" data-id="element-383">Application</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-384">
            <h2 className="text-2xl font-medium" data-id="element-385">Application Process</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-386">
              <p data-id="element-387">
                Aspect works with a vetted network of professional architectural
                photographers.
              </p>
              <p data-id="element-388">
                Applications are reviewed based on portfolio, project types, and
                geographic coverage.
              </p>
              <div className="pt-4" data-id="element-389">
                <Link to="/photographers/apply" data-id="element-390">
                  <Button variant="primary" icon data-id="element-391">
                    Apply to work with aspect
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>;
}